import { format } from 'date-fns';
import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { DATE_PICKER_FORMAT_MONTH } from '../../../../../../../../@constants/date';
import {
  FilterEnum,
  FourWeekForecastReportFormModel,
  GroupByEnum,
  SubFilterEnum,
} from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): FourWeekForecastReportFormModel => ({
  month: format(new Date(globalSettings?.frontend_date), DATE_PICKER_FORMAT_MONTH),
  company: null,
  rates: [],
  roomTypeIds: [],
  with_revenue: false,
  currency: null,
  currency_application: null,
  fixed_at: '',
  sub_filter: SubFilterEnum.NONE,
  filter: FilterEnum.ROOM,
  gross_revenue: false,
  group_by: GroupByEnum.MARKET_SEGMENT,
  file_type: 'pdf',
});
